import { makeStyles } from '@material-ui/core/styles';

export function useManagementLayoutStyles() {
    const useStyles = makeStyles((theme) => ({
        root: {
            margin: 0,
            height: '100%',
        },
        content: {
            flex: 1,
            padding: 24,
            overflowY: 'auto',
            overflowX: 'hidden',
            backgroundColor: '#F5F5F5',
        },
    }));

    const classes = useStyles();

    return {
        classes,
    };
}